import { Edit, SimpleForm } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditHospitalContractCampaign = () => {
  return (
    <Edit
      title="Редакция на договор с болница"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm isEdit />
      </SimpleForm>
    </Edit>
  );
};
export default EditHospitalContractCampaign;
